import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { LoginComponent } from './pages/unsecure/login/login.component';
import { LoginMfaComponent } from './pages/unsecure/login/login-mfa/login-mfa.component';
import { PageNotFoundComponent } from './pages/unsecure/page-not-found/page-not-found.component';
import { RegisterComponent } from './pages/unsecure/register/register.component';
import { AccountDisabledComponent } from './pages/unsecure/account-disabled/account-disabled.component';
import { ResetPasswordComponent } from './pages/unsecure/reset-password/reset-password.component';

import { CoreModule } from './core/core.module';
import { HomeModule } from './pages/secure/home/home.module';
import { SharedModule } from './shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { CertificatesHubService } from './shared/services/certificates-hub.service';
import { HelpModule } from './pages/unsecure/help/help.module';
registerLocaleData(localeNl, 'nl-NL');

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({ declarations: [
        AppComponent,
        LoginComponent,
        LoginMfaComponent,
        PageNotFoundComponent,
        RegisterComponent,
        AccountDisabledComponent,
        ResetPasswordComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        SharedModule, // TODO: Create also an UnsecureModule and remove sharedModule from appModule
        NgxMatSelectSearchModule,
        AppRoutingModule,
        ToastrModule.forRoot({
            timeOut: 5000,
            positionClass: 'toast-bottom-right',
            preventDuplicates: false,
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        CoreModule,
        HomeModule,
        HelpModule,
        MatBadgeModule], providers: [ToastrService, CertificatesHubService, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {}
